define(["underscore"], function(__WEBPACK_EXTERNAL_MODULE__9__) { return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 390);
/******/ })
/************************************************************************/
/******/ ({

/***/ 390:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(391);


/***/ }),

/***/ 391:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _index = __webpack_require__(392);

Object.keys(_index).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _index[key];
    }
  });
});

/***/ }),

/***/ 392:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _errorMessages = __webpack_require__(393);

Object.keys(_errorMessages).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _errorMessages[key];
    }
  });
});

var _errorHandlers = __webpack_require__(394);

Object.keys(_errorHandlers).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _errorHandlers[key];
    }
  });
});

var _getMessageForCode = __webpack_require__(395);

Object.keys(_getMessageForCode).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _getMessageForCode[key];
    }
  });
});

var _getErrorFromRaw = __webpack_require__(396);

Object.keys(_getErrorFromRaw).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _getErrorFromRaw[key];
    }
  });
});

/***/ }),

/***/ 393:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ERROR_MESSAGES = void 0;
const ERROR_MESSAGES = {
  InvalidValue: _TL_('Invalid value'),
  ad: {
    InvalidValue: _TL_('Invalid ad'),
    url: {
      InvalidValue: _TL_('Invalid ad url')
    },
    title1: {
      InvalidValue: _TL_('Invalid ad title1')
    }
  },
  business: {
    InvalidValue: _TL_('Invalid business'),
    url: {
      InvalidValue: _TL_('Invalid business url')
    },
    name: {
      InvalidValue: _TL_('Invalid business name')
    }
  }
};
exports.ERROR_MESSAGES = ERROR_MESSAGES;

/***/ }),

/***/ 394:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ccErrorHandler = exports.odataErrorHandler = exports.getParsedIndexAndProperty = exports.errorPropertyReg = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(9));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const errorPropertyReg = /((.+)\[(\d+)\]){0,1}(\.)?(.+)?/;
exports.errorPropertyReg = errorPropertyReg;

const getParsedIndexAndProperty = errorProperty => {
  if (!errorProperty) {
    return {
      index: null,
      property: null
    };
  }

  const res = errorPropertyReg.exec(errorProperty);
  const property = !res[5] && res[2] ? res[2] : res[5];
  return {
    index: res[3],
    property
  };
};

exports.getParsedIndexAndProperty = getParsedIndexAndProperty;

const odataErrorHandler = (rawError, entity, field, getErrorMessage, useServerErrorMessage) => {
  let errors = [];

  if (_underscore.default.isArray(rawError)) {
    errors = rawError;
  } else if (_underscore.default.isObject(rawError)) {
    if (rawError['@odata.context'] && _underscore.default.isArray(rawError.value)) {
      errors = rawError.value;
    } else if (_underscore.default.isArray(rawError.responseJSON)) {
      errors = rawError.responseJSON;
    } else if (_underscore.default.isObject(rawError.responseJSON) && _underscore.default.isArray(rawError.responseJSON.Errors)) {
      errors = rawError.responseJSON.Errors;
    }
  }

  const entityErrors = {};
  errors.forEach(e => {
    const _getParsedIndexAndPro = getParsedIndexAndProperty(e.Property),
          errProperty = _getParsedIndexAndPro.property;

    const errField = field || errProperty || ''; // entity level errors are stored on param ''

    const error = {
      errorCode: e.Code,
      message: getErrorMessage({
        errorCode: e.Code,
        entity,
        field: field || errProperty,
        serverErrorMessage: useServerErrorMessage && e.Message,
        errMsgObj: e.ErrMsgObj
      }),
      clientId: e.ClientId
    };

    if (entityErrors[errField]) {
      entityErrors[errField].push(error);
    } else {
      entityErrors[errField] = [error];
    }
  });
  return entityErrors;
};

exports.odataErrorHandler = odataErrorHandler;

const ccErrorHandler = (rawError, entity, field, getErrorMessage) => {
  const defaultErrorCode = `ResultType${rawError.ResultType}`;

  if (_underscore.default.isEmpty(rawError.Errors)) {
    return {
      [field || '']: [{
        errorCode: defaultErrorCode,
        message: getErrorMessage({
          errorCode: defaultErrorCode,
          entity,
          field
        }),
        clientId: rawError.ClientId
      }]
    };
  }

  const entityErrors = {};
  rawError.Errors.forEach(e => {
    const errorCode = e.Code || defaultErrorCode;
    const errField = field || e.FieldId || '';
    const error = {
      errorCode,
      message: getErrorMessage({
        errorCode,
        entity,
        field: field || e.FieldId
      }),
      clientId: e.ClientId
    };

    if (entityErrors[errField]) {
      entityErrors[errField].push(error);
    } else {
      entityErrors[errField] = [error];
    }
  });
  return entityErrors;
};

exports.ccErrorHandler = ccErrorHandler;

/***/ }),

/***/ 395:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMessageForErrorCodeFn = exports.getMessageForErrorCode = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(9));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
PRIORITY LIST:
  case1. Entity + field + error code
  case2. field + error code
  case3. No field + entity + error code
  case4. error code
  case5. Entity + field + server error message
  case6. Return error code without mapping as last option
errorMap structure for above case handling:
  {
    entity: {
      field: {
        errorCode: 'case1',
      },
      errorCode: 'case3',
    },
    field: {
      errorCode: 'case2',
    },
    errorCode: 'case4'
  }
*/
const getMessageForErrorCode = (i18n, instrumentation, errorMap, {
  errorCode,
  entity,
  field,
  serverErrorMessage,
  errMsgObj = {}
}) => {
  if (entity && field && errorMap[entity] && errorMap[entity][field] && errorMap[entity][field][errorCode] && _underscore.default.isString(errorMap[entity][field][errorCode])) {
    return i18n.getString(errorMap[entity][field][errorCode], errMsgObj);
  }

  if (field && errorMap[field] && errorMap[field][errorCode] && _underscore.default.isString(errorMap[field][errorCode])) {
    return i18n.getString(errorMap[field][errorCode], errMsgObj);
  }

  if (!field && entity && errorMap[entity] && errorMap[entity][errorCode] && _underscore.default.isString(errorMap[entity][errorCode])) {
    return i18n.getString(errorMap[entity][errorCode], errMsgObj);
  }

  if (errorMap[errorCode] && _underscore.default.isString(errorMap[errorCode])) {
    return i18n.getString(errorMap[errorCode], errMsgObj);
  }

  if (entity && field && serverErrorMessage) {
    if (instrumentation && instrumentation.logTrace) {
      instrumentation.logTrace(`Error string not found for error code: ${errorCode}; entity: ${entity}; field: ${field}; using the server error message for now: ${serverErrorMessage}`);
    }

    return serverErrorMessage;
  }

  if (instrumentation && instrumentation.logError) {
    instrumentation.logError(`Error string not found for error code: ${errorCode}; entity: ${entity}; field: ${field}`);
  }

  return i18n.getString(_TL_('An unknown error occurred'));
};

exports.getMessageForErrorCode = getMessageForErrorCode;

const getMessageForErrorCodeFn = (i18n, instrumentation, errorMap) => args => getMessageForErrorCode(i18n, instrumentation, errorMap, args);

exports.getMessageForErrorCodeFn = getMessageForErrorCodeFn;

/***/ }),

/***/ 396:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getErrorFromRawFn = exports.getErrorFromRaw = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(9));

var _getMessageForCode = __webpack_require__(395);

var _errorHandlers = __webpack_require__(394);

var _errorMessages = __webpack_require__(393);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// server error code is not unique for now, so we temporarily depend on server error messages
// when MT fixed this error code issue, we should not use server error message any more
const getErrorFromRaw = (i18n, instrumentation, errorMap, rawError, entity, field, useServerErrorMessage = false) => {
  const errorMapper = (0, _getMessageForCode.getMessageForErrorCodeFn)(i18n, instrumentation, errorMap);

  if (_underscore.default.isObject(rawError)) {
    if (_underscore.default.isNumber(rawError.ResultType)) {
      return (0, _errorHandlers.ccErrorHandler)(rawError, entity, field, errorMapper);
    }
  }

  return (0, _errorHandlers.odataErrorHandler)(rawError, entity, field, errorMapper, useServerErrorMessage);
};

exports.getErrorFromRaw = getErrorFromRaw;

const getErrorFromRawFn = (i18n, instrumentation, errorMap = _errorMessages.ERROR_MESSAGES) => (...args) => getErrorFromRaw(i18n, instrumentation, errorMap, ...args);

exports.getErrorFromRawFn = getErrorFromRawFn;

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__9__;

/***/ })

/******/ })});;
